module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 22
// module chunks = 0